import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './App.css';
import { FaDownload, FaCheck, FaStamp } from 'react-icons/fa';

function App() {
  const [inn, setInn] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [visitorCount, setVisitorCount] = useState(0);
  const [showStampOption, setShowStampOption] = useState(false);

  useEffect(() => {
    axios.get('/api/visitors')
      .then(response => {
        setVisitorCount(response.data.count);
      })
      .catch(error => {
        console.error('Ошибка при получении счетчика:', error);
        setVisitorCount(300);
      });
  }, []);

  const searchCertificates = async (e) => {
    e.preventDefault();
    if (!inn || !searchQuery) return;

    setLoading(true);
    setError('');
    setCertificates([]);

    try {
      const response = await axios.post('/api/search-certificates', {
        inn,
        searchQuery
      });

      if (response.data.answerjson && response.data.answerjson.length > 0) {
        const certsWithOrg = response.data.answerjson.map(cert => ({
          ...cert,
          org: response.data.org
        }));
        setCertificates(certsWithOrg);
      } else {
        const errorMessage = response.data.answer || 'Сертификаты не найдены';
        setError(errorMessage);
      }
    } catch (err) {
      console.error('Ошибка при поиске сертификатов:', err);
      setError('Произошла ошибка при поиске сертификатов');
    } finally {
      setLoading(false);
    }
  };

  const downloadFile = (filePath, org) => {
    const url = `/download?path=${encodeURIComponent(filePath)}&stamp=${showStampOption}&org=${encodeURIComponent(org)}`;
    window.open(url, '_blank');
  };

  const downloadAllFiles = (filePaths, org) => {
    const url = `/download-all?paths=${encodeURIComponent(JSON.stringify(filePaths))}&stamp=${showStampOption}&org=${encodeURIComponent(org)}`;
    window.open(url, '_blank');
  };

  const downloadAllCertificates = () => {
    if (certificates.length === 0) {
      setError('Нет сертификатов для скачивания');
      return;
    }
    
    const allFilePaths = certificates.reduce((acc, cert) => {
      if (cert.path && cert.path.length > 0) {
        return [...acc, ...cert.path];
      }
      return acc;
    }, []);
    
    if (allFilePaths.length === 0) {
      setError('Нет файлов для скачивания');
      return;
    }
    
    const org = certificates[0].org;
    downloadAllFiles(allFilePaths, org);
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>Поиск сертификатов</h1>
        <div className="visitor-counter">
          Посетителей сегодня: {visitorCount}
        </div>
      </header>

      <main className="container">
        <form onSubmit={searchCertificates} className="search-form">
          <div className="form-group">
            <label htmlFor="inn">ИНН:</label>
            <input
              type="text"
              id="inn"
              value={inn}
              onChange={(e) => setInn(e.target.value)}
              placeholder="Введите ИНН"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="searchQuery">Номер накладной или артикул товара:</label>
            <input
              type="text"
              id="searchQuery"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Введите номер накладной или артикул товара"
              required
            />
          </div>

          <div className="form-actions">
            <button type="submit" disabled={loading || !inn || !searchQuery}>
              {loading ? 'Поиск...' : 'Найти'}
            </button>
            
            <div 
              className={`stamp-option ${showStampOption ? 'active' : ''}`}
              onClick={() => setShowStampOption(!showStampOption)}
            >
              <div className="stamp-checkbox">
                {showStampOption ? <FaCheck className="check-icon" /> : null}
              </div>
              <FaStamp className="stamp-icon" />
              <span>Добавить печать</span>
            </div>
          </div>
        </form>

        {error && <div className="error-message">{error}</div>}

        {certificates.length > 0 && (
          <>
            <button className="download-all-btn" onClick={downloadAllCertificates}>
              <FaDownload /> Скачать все сертификаты
            </button>
            <table className="certificates-table">
              <thead>
                <tr>
                  <th>Наименование</th>
                  <th>Артикул</th>
                  <th>Сертификат</th>
                  <th>Файлы</th>
                </tr>
              </thead>
              <tbody>
                {certificates.map((cert, index) => {
                  const allFilePaths = cert.path || [];
                  return (
                    <tr key={index}>
                      <td>{cert.name}</td>
                      <td>{cert.article}</td>
                      <td>{cert.certificate}</td>
                      <td>
                        <div className="file-actions">
                          {allFilePaths.length === 1 ? (
                            <button 
                              className="download-btn"
                              onClick={() => downloadFile(allFilePaths[0], cert.org)}
                            >
                              <FaDownload /> Скачать
                            </button>
                          ) : (
                            <button 
                              className="download-btn"
                              onClick={() => downloadAllFiles(allFilePaths, cert.org)}
                            >
                              <FaDownload /> Скачать все ({allFilePaths.length})
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </>
        )}
      </main>
      <div className="visitor-counter">
        Уникальных пользователей: {visitorCount}
      </div>
    </div>
  );
}

export default App;